module.exports = __webpack_public_path__ + "img/email.a8976cac.svg";